<template>
  <div>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             color="green"
             loader="dots"
    ></loading>
    <div class="row">
      <div class="col-md-12 col-12">
        <h3 class="title m-t-10 m-l-15">{{ library ? library.title : '' }}</h3>
        <ol class="breadcrumb" style="margin-top: -20px">
          <li class="breadcrumb-item"><a href="/"><i class="mdi mdi-home"></i> На головну</a></li>
          <li class="breadcrumb-item"><a href="/library/acquisition-batches"><i class="mdi mdi-folder-multiple-outline"></i>
            Комплектування</a></li>
          <li class="breadcrumb-item active">Редагування інформації</li>
        </ol>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row m-3">
          <h4 class="title" v-if="$route.name === 'acquisitionBatchesCreate'">Нова Партія</h4>
          <h4 class="title" v-else>Форма редагування</h4>
        </div>
        <div class="m-3 floating-labels reader-form">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label for="doc_number" class="floatings">НОМЕР ДОКУМЕНТА</label>
                <input type="text" class="form-control" id="doc_number" v-model="acquisitionBatch.doc_number" ref="doc_number" :class="errors.hasOwnProperty('doc_number') ? 'is-invalid' : ''" @input="delete errors.doc_number" />
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('doc_number')">
                  <span v-for="item in errors.doc_number">{{ item }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="doc_date" class="floatings">ДАТА ДОКУМЕНТА</label>
                <datepicker :language="uk" :input-class="'form-control'" :monday-first="true" :format="'yyyy-MM-dd'" id="doc_date" v-model="acquisitionBatch.doc_date" :class="errors.hasOwnProperty('doc_date') ? 'is-invalid' : ''" @input="delete errors.doc_date"></datepicker>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('doc_date')">
                  <span v-for="item in errors.doc_date">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label for="source" class="floatings">ДЖЕРЕЛО</label>
                <v-select id="source"
                          v-model="acquisitionBatch.source"
                          :options="listDropDown"
                          label="source"
                          class="form-control"
                          placeholder=" "
                          @search="getUniqueValues('source',$event)"
                          :filterable="false"
                          @search:focus="getUniqueValues('source','')"
                          :taggable="true"
                          :create-option="source => source"
                          ref="source"
                          :class="errors.hasOwnProperty('source') ? 'is-invalid' : ''"
                          @input="delete errors.source"
                          :value="acquisitionBatch.source">
                  <template #no-options="{ search, searching, loading }">
                    Джерело не знайдено
                  </template>
                </v-select>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('source')">
                  <span v-for="item in errors.source">{{ item }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="general_type" class="floatings">ЗАГАЛЬНИЙ ТИП</label>
                <v-select id="general_type"
                          v-model="acquisitionBatch.general_type"
                          :options="listDropDown"
                          label="general_type"
                          class="form-control"
                          placeholder=" "
                          @search="getUniqueValues('general_type',$event)"
                          :filterable="false"
                          @search:focus="getUniqueValues('general_type','')"
                          :taggable="true"
                          :create-option="general_type => general_type"
                          ref="general_type"
                          :class="errors.hasOwnProperty('general_type') ? 'is-invalid' : ''"
                          @input="delete errors.general_type">
                  <template #no-options="{ search, searching, loading }">
                    Тип не знайдено
                  </template>
                </v-select>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('general_type')">
                  <span v-for="item in errors.general_type">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label for="total_sum" class="floatings">СУММА ЗАМОВЛЕННЯ</label>
                <input type="number" class="form-control" id="total_sum" ref="total_sum" v-model="acquisitionBatch.total_sum" :class="errors.hasOwnProperty('total_sum') ? 'is-invalid' : ''" @input="delete errors.total_sum" />
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('total_sum')">
                  <span v-for="item in errors.total_sum">{{ item }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="total_amount_of_books" class="floatings">КІЛЬКІСТЬ КНИЖОК</label>
                <input type="number" class="form-control" id="total_amount_of_books" ref="total_amount_of_books" v-model="acquisitionBatch.total_amount_of_books" :class="errors.hasOwnProperty('total_amount_of_books') ? 'is-invalid' : ''" @input="delete errors.total_amount_of_books" />
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('total_amount_of_books')">
                  <span v-for="item in errors.total_amount_of_books">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group upload_file">
                <label class="upload_file__lable" :class="errors.hasOwnProperty('file') ? 'is-invalid' : ''">
                  <span class="upload_file__title">СУПРОВІДНИЙ ДОКУМЕНТ</span>
                  <input type="file" class="form-control-file" name="file" ref="file" @change="changeFile">
                  <span class="upload_file__filename" v-if="uploadedFile">{{ uploadedFile.name }}</span>
                </label>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('file')">
                  <span v-for="item in errors.file">{{ item }}</span>
                </div>
                <span v-if="acquisitionBatch.file">Поточний файл: <a :href=acquisitionBatch.file download>{{ acquisitionBatch.file.replace(/.+\//, '') }}</a></span>
                <span class="bar"></span>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label for="comment" class="floatings">КОММЕНТАР</label>
                <textarea id="comment" v-model="acquisitionBatch.comment" ref="comment" rows="5" :class="errors.hasOwnProperty('comment') ? 'is-invalid' : ''" @input="delete errors.comment"></textarea>
                <span class="bar"></span>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('comment')">
                  <span v-for="item in errors.comment">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group float-sm-right m-b-40 m-r-15" id="save-cancel">
          <div  class="btn btn-outline-secondary btn-lg mt-auto mb-auto" style="padding: 14px">
            <a :href="acquisitionBatch.id ? '/library/acquisition-batches/' + acquisitionBatch.id : '/library/acquisition-batches'"
               style="font-size: 15px;">
              <i class="mdi mdi-close-circle"></i> Скасувати
            </a>
          </div>
          <button @click="saveAcquisitionBatch" class="btn btn-success btn-lg m-l-20" type="submit" style="font-size: 15px"><i
              class="mdi mdi-check-circle"></i> Зберегти
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';
import {uk} from 'vuejs-datepicker/dist/locale';
export default {
  name: "AcquisitionBatchCreateEdit",
  components: {Loading, Datepicker},
  data() {
    return {
      uk: uk,
      library: null,
      isLoading: false,
      fullPage: true,
      uploadedFile: {},
      allowedMimeTypes: {
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        pdf: 'application/pdf',
      },
      acquisitionBatch: {
        id: '',
        library_id: '',
        doc_number: '',
        doc_date: '',
        comment: '',
        source: '',
        general_type: '',
        file: '',
        total_sum: '',
        total_amount_of_books: '',
        status: '',
      },
      errors: {},
      listDropDown: [],
    }
  },
  mounted() {
    if (this.$route.name == 'acquisitionBatchEdit') {
      this.getAcquisitionBatch(this.$route.params.id);
    } else {
      this.getLibrary();
    }
  },
  methods: {
    changeFile(e) {
      delete this.errors.file;
      this.uploadedFile = e.target.files[0];
    },

    isFiletypeAllowed(file) {
      return Object.values(this.allowedMimeTypes).indexOf(file.type) > -1;
    },

    saveAcquisitionBatch() {
      this.isLoading = true;
      let form = new FormData();
      let url, method;
      if (this.$route.name === 'acquisitionBatchesCreate') {
        url = '/library/acquisition-batches';
        method = 'post';
      } else if (this.$route.name === 'acquisitionBatchEdit') {
        method = 'put';
        url = '/library/acquisition-batches/' + this.acquisitionBatch.id;
      }
      form.append('_method', method);

      for (let item in this.acquisitionBatch) {
        if ('file' === item) {
          if (this.uploadedFile && this.uploadedFile.name) {
            form.append(item, this.uploadedFile);
          }
        } else if ('doc_date' === item) {
          let date = new Date(this.acquisitionBatch[item]);
          let month = date.getMonth() + 1;
          month = month < 10 ? '0' + month : month;
          let day = date.getDate();
          day = day < 10 ? '0' + day : day;
          date = date.getFullYear() + '-' + month + '-' + day;
          form.append(item, date);
        } else if (null === this.acquisitionBatch[item]) {
          continue;
        } else {
          form.append(item, this.acquisitionBatch[item]);
        }
      }

      this.$nextTick(() => {
        axios.post(url, form).then(response => {
          this.isLoading = false;
          if (this.$route.name === 'acquisitionBatchEdit') {
            window.location.href = '/library/acquisition-batches/' + this.acquisitionBatch.id;
          } else {
            window.location.href = '/library/acquisition-batches/';
          }
        }).catch(error => {
          this.isLoading = false;
          this.errors = error.response.data.errors;
          console.log('Errors:');
          console.log(error.response.data.errors);
        });
      });
    },
    getUniqueValues(field, title) {
      this.listDropDown = [];
      axios.get('/library/acquisition-batches?field=' + field + '&title=' + title).then(response => {
        if (!response.data.length) {
          return;
        }
        this.listDropDown = response.data.map(el => {
          return el;
        });
      });
    },
    getLibrary(){
      axios.get('/library').then(res => {
        this.library = res.data;
        this.acquisitionBatch.library_id = this.library.id;
      })
    },

    getAcquisitionBatch(id) {
      axios.get('/library/acquisition-batches/' + id + '/getForEdit').then(response => {
        if (response.data.acquisitionBatch) {
          this.acquisitionBatch = response.data.acquisitionBatch;
          this.acquisitionBatch.comment = this.acquisitionBatch.comment ? this.acquisitionBatch.comment : '';
        }
      });
    },
  },
}
</script>

<style scoped>
    textarea.form-control {
      height: 16.3em;
      resize: none;
      /*color: #9E9E9E;*/
      font-size: 13px;
      line-height: 22px;
      border: none !important;
      margin-bottom: 10px
    }
    .form-control >>> .vs__open-indicator{
      transition: unset;
    }
  .form-control >>> .vs__dropdown-toggle,
  .form-control >>> .vs__dropdown-menu {
    font-size: 13px;
    border: none;
  }

  .form-control >>> .vs__actions {
    padding: 0;
    margin-right: -5px;
    align-items: unset;
  }
  .form-control >>> input.vs__search{
    padding: 0px;
  }

  .form-control >>> .vs__search,
  .form-control >>> .vs__selected {
    font-size: 13px;
    color: #414141;
    white-space: unset;
    padding: 5px;
    margin: 10px 5px 0 0 !important;
  }

  .form-group >>> .v-select{
    height: 40px;
    overflow: hidden;
  }
  .form-group >>> .v-select.vs--single:hover{
    overflow: unset;
  }
  .form-group >>> .v-select.vs--single .vs__selected-options .vs__selected{
    padding: 0;
    white-space: nowrap;
    width: 90%;
  }
  .form-group >>> .v-select.active,
    /*.form-group >>> .v-select:hover,*/
  .form-group >>> .v-select:focus-within {
    height: unset;
    overflow: unset;
  }

  .form-group >>>.vs__selected-options {
    width: 90%;
    overflow: hidden;
    padding: 0;
  }

  .form-control {
    min-height: 40px;
    color: #414141;
  }

  input {
    font-size: 13px;
  }

  .upload_file {
    margin-top: 20px;
  }

  .upload_file__lable {
    position: relative;
    display: block;
    max-width: 200px;
    width: 100%;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    background: orange;
    cursor: pointer;
  }

  .upload_file__lable input {
    display: none;
  }

  .upload_file__title {
    text-align: -moz-center;
    text-align: -webkit-center;
    text-align: center;
    color: #ffffff;
  }

  .upload_file__filename {
    position: absolute;
    left: 105%;
  }

  #comment {
    width: 100%;
  }

  .invalid-feedback {
    display: block;
  }

  .invalid-feedback span {
    display: block;
  }
</style>